import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Announcements = () => {

  const  servicesFaqData = [
    { 
        question: "What are announcement prints, and where can they be used? ", 
        answer: "Announcement prints are high-quality cards designed to share news, invitations, or updates for personal or professional occasions. They are commonly used for weddings, corporate events, milestone celebrations, and formal announcements. These prints provide a sophisticated and tangible way to communicate important information. Announcement cards are versatile and can be customised to match the tone and style of the event or message. Their elegance and professionalism make them an ideal choice for conveying meaningful updates."
    },
    { 
        question: "What are the benefits of professional announcement printing?  ", 
        answer: "Professional announcement printing ensures your cards have a polished and luxurious finish, leaving a lasting impression. With customisation options, you can choose designs, fonts, and materials that reflect the tone of your message. High-quality printing technology guarantees vibrant colours, sharp details, and premium textures. Professionally printed announcements convey a sense of elegance and attention to detail, making them ideal for weddings, corporate events, and formal celebrations. These cards elevate your message, making it memorable and impactful."
    },
    { 
        question: "Can Printingy handle bulk orders for announcement printing?  ", 
        answer: "Printingy specialises in bulk announcement printing, offering cost-effective solutions for large-scale orders. Bulk printing reduces per-unit costs, making it an economical option for events with extensive guest lists or corporate communications. We ensure consistent quality across all prints, regardless of the order size. With quick turnaround times, we guarantee your announcements are ready on schedule, even for urgent orders. Printingy’s bulk printing services are reliable and efficient, whether for weddings, company announcements, or invitations."
    },
    { 
        question: "What materials are used for wedding announcement printing? ", 
        answer: "Our wedding announcement printing services use premium textured cardstock, foil-accented paper, and luxurious finishes. Textured cardstock provides a classic and elegant appearance, perfect for formal wedding announcements. The foil-accented paper adds a touch of glamour, with metallic details that make the cards stand out. We also offer options like embossing, matte or glossy finishes, and high-resolution printing to enhance the visual appeal. These materials ensure your wedding announcements are sophisticated, durable, and reflect the special occasion."
    },
    { 
        question: "What industries and individuals benefit from invitation card printing services? ", 
        answer: "Event planners, corporate organisations, and individuals benefit significantly from invitation card printing services. Event planners use these services to create elegant invitations for weddings, galas, and formal gatherings. Corporates rely on printed invitation cards for company events, product launches, and client meetings. Individuals use these services to celebrate milestones such as birthdays, anniversaries, and personal achievements. Custom invitation cards enhance the formality and significance of any occasion, making them an indispensable tool for effective communication."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Announcements');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title=" Professional Announcement Printing Services"
  description="High-quality printing of announcements and invitation cards for events. Bulk announcement printing, professional announcement printing, and wedding announcement printing solutions."
  keywords="Printing of Announcements,
Invitation Cards Printing,
Announcement Printing,
Professional Announcement Printing,
Wedding Announcement Printing
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Announcements </h1>
              <h2 className="text-muted">Custom announcement printing for events, weddings, and invitations  </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Announcements are a timeless way to share news, invitations, or special updates with elegance and style. Printingy specialises in the Printing of Announcements, offering high-quality announcement printing services for personal and professional needs.</p>
          <p>Our services include invitation card printing for weddings, corporate events, and social gatherings, ensuring your message is delivered with sophistication. For formal occasions, we provide professional announcement printing with tailored designs that align with your style or brand. Additionally, we specialise in wedding announcement printing, creating customised cards that make your special day unforgettable.</p>
          <p>Whether for personal celebrations or corporate communication, Printingy ensures vibrant colours, premium materials, and bulk printing options that meet your requirements.</p>
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Announcement Printing Solutions  </h2>
                <h3 className="large-hed">Elegant, high-quality announcements for every occasion  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Announcements for personal and professional use. 
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk announcement printing at competitive rates for large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully customised invitation card printing to suit your event.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional wedding announcement printing with premium finishes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and luxurious materials for a sophisticated appearance.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for sharp details and vibrant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for individuals, event organisers, and businesses.

                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/announcements.jpg" // Path relative to the public folder
                  alt="High-quality printing of announcements services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Announcements Delivered On Time </h2>
            <h3 className="small-hed">Focus on your event while we handle your announcement printing needs  </h3>
            <p>At Printingy, we combine premium materials with advanced printing techniques to deliver exceptional announcement printing solutions. Whether for weddings, corporate events, or personal celebrations, our professional announcement printing services ensure your cards are visually stunning and memorable.
            </p>
            <p>With a focus on quality and efficiency, Printingy guarantees timely delivery for all bulk orders, ensuring your announcements are ready to share on schedule.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Announcements;
